export default __webpack_public_path__ + "static/media/img11.7f849c3d.png";